var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.ADMIN.admin!=undefined)?_c('app-tool-bar'):_vm._e(),_c('v-main',{staticClass:"app"},[(_vm.ADMIN.admin!=undefined)?_c('router-view'):_c('login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }